/**
 * @license Givaudan. All rights reserved. This
 * @author Ayoub MHAMDI
 */

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DISPLAY_LOADER } from '@banyan/commons/contexts/httpContextToken.context';
import { ProgressSpinnerService } from '@banyan/modules/shared/services/progress-spinner/progress-spinner.service';
import { finalize, Observable } from 'rxjs';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  progressSpinnerService = inject(ProgressSpinnerService);

  constructor() {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.context.get(DISPLAY_LOADER)) {
      this.progressSpinnerService.show();
    }
    return next.handle(request).pipe(
      finalize(() => {
        if (request.context.get(DISPLAY_LOADER)) {
          this.progressSpinnerService.hide();
        }
      }),
    );
  }
}
